import React from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";

const Modal = ({ isOpen, handleModalToggle, modalData, submitHandler }) => {
  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleModalToggle}
      className="bg-transparent shadow-none"
    >
      <Card className="mx-auto w-full max-w-[24rem]">
        <CardBody className="flex flex-col gap-2">
          <Typography variant="h4" color="blue-gray">
            {modalData.title}
          </Typography>
          <Typography
            className="mb-3 font-normal"
            variant="paragraph"
            color="gray"
          >
            {modalData.description}
          </Typography>
        </CardBody>
        <CardFooter className="flex justify-end gap-3 pt-0 ">
          {modalData.redButton && (
            <Button
              className={`px-2 w-28 py-2 bg-${
                modalData.backgroundColor || "red-800"
              }`}
              onClick={(e) =>
                modalData.flag
                  ? submitHandler(modalData.redButton)
                  : handleModalToggle()
              }
            >
              {modalData.redButton}
            </Button>
          )}
          {modalData.purpleButton && (
            <Button
              className="px-2 py-2 w-28 bg-theme-color"
              onClick={() => submitHandler(modalData.purpleButton)}
            >
              {modalData.purpleButton}
            </Button>
          )}
        </CardFooter>
      </Card>
    </Dialog>
  );
};

export default Modal;
